import baseStyleInjector from "../../../assets/styles/FormBase.style";

const stylizer = theme => baseStyleInjector(theme);

export default stylizer;
